import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMediaQuery } from "./chunk-MG6WC47T.mjs";

// src/visibility.tsx
function Visibility(props) {
  var breakpoint = props.breakpoint,
    hide = props.hide,
    children = props.children,
    ssr = props.ssr;
  var _useMediaQuery = useMediaQuery(breakpoint, {
      ssr: ssr
    }),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    show = _useMediaQuery2[0];
  var isVisible = hide ? !show : show;
  var rendered = isVisible ? children : null;
  return rendered;
}
export { Visibility };